'use client';

import React, { useState } from 'react';
import NavBar from '@/components/header/NavBar';
import Why from '@/components/whySection';
import { FaAngleDoubleRight } from "react-icons/fa";
import ContactForm from '@/components/ContactForm/ContactForm';
import FAQContainer from '@/components/FAQContainer/FAQContainer';
import Footer from '@/components/Footer/Footer';
import AnimatedCopy from '@/components/AnimatedCopy/AnimatedCopy';
import Image from "next/image";
import { useRouter } from 'next/navigation'; // Import useRouter
import useFetchPosts from "@/components/post/fetcher";
import { useLocale } from "next-intl";


const ContactForms: React.FC = () => {

  const l = useLocale();
  const router = useRouter(); // Initialize the router
  const { posts, error, isLoading } = useFetchPosts();
  const [searchQuery, setSearchQuery] = useState('');

  const getLocalizedField = (item: any, field: string) => item[`${field}_${l}`] || item[`${field}_en`];

  const filteredPosts = posts.filter((post) =>
    getLocalizedField(post, "title")
      ?.toLowerCase()
      .includes(searchQuery.toLowerCase())
  );

  return (
  
  <>
  {/* Fixed background — stays behind everything while page scrolls */}

  <div
    className="bg-cover bg-center bg-no-repeat h-96 lg:h-[500px] relative rounded-b-3xl"
    style={{ backgroundImage: `url('/hero/trends.avif')` }}
  >
   
<div className="absolute inset-0 bg-secondary/55 h-96 lg:h-[500px] rounded-b-3xl" />
  <h1 className="absolute inset-0 flex items-center pt-40 justify-center text-white text-5xl lg:text-9xl font-extrabold text-center px-4 ">
    Digital Trends
  </h1>
    
  </div>

  <NavBar />

 <div className="p-2 lg:p-12">
      <div className="flex justify-center gap-2 flex-wrap items-center bg-white">
       
       <input
  type="search"
  placeholder="Search..."
  value={searchQuery}
  onChange={(e) => setSearchQuery(e.target.value)}
  className="py-4 px-8 w-full mt-4 lg:mt-0 lg:w-1/2 rounded-full text-lg bg-background ring-1 ring-secondary/40  text-primary placeholder-secondary/50 outline-none focus:ring-2 focus:ring-white/50 transition-colors duration-300"
/>
      </div>

      <div className="grid grid-cols-1  md:grid-cols-3 gap-6 lg:gap-16 mt-12 mb-12 lg:mb-0">
        {filteredPosts.length === 0 ? (
          <p className="text-lg text-secondary/60 col-span-full">No results found.</p>
        ) : (
          filteredPosts.map((post, i) => (
            <div key={i} className="group space-y-4 cursor-pointer">
              <div 
              onClick={() => router.push(`/blog/${getLocalizedField(post, 'url')}`)}
              className="relative w-full h-80 md:h-60 lg:h-[420px] rounded-3xl overflow-hidden shadow-lg transition-all duration-500 ease-out group-hover:shadow-2xl group-hover:-translate-y-2">
                <Image
                  src={`${process.env.NEXT_PUBLIC_IMAGE}/${getLocalizedField(post, "image")}`}
                  alt="padel-book-alt"
                  quality={100}
                  fill
                  sizes="50vw"
                  className="object-cover rounded-3xl transition-transform duration-700 ease-out group-hover:scale-110"
                  priority
                />

                {/* Gradient overlay that fades in on hover */}
                <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-black/10 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-500" />

                {/* Arrow badge that pops in on hover */}
                <div className="absolute top-5 right-5 w-10 h-10 rounded-full bg-white/90 flex items-center justify-center opacity-0 translate-y-2 group-hover:opacity-100 group-hover:translate-y-0 transition-all duration-500 delay-100">
                  <svg
                    width="18"
                    height="18"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  >
                    <path d="M7 17L17 7" />
                    <path d="M7 7h10v10" />
                  </svg>
                </div>
              </div>

              <h4
              onClick={() => router.push(`/blog/${getLocalizedField(post, 'url')}`)}
              className="text-xl lg:text-3xl font-bold transition-colors duration-300 group-hover:text-primary">
                {getLocalizedField(post, "title")}
              </h4>
            </div>
          ))
        )}
      </div>
    </div>
<ContactForm/>

<Footer/>
</>
  );
};

export default ContactForms;